 // src/components/Header.js
import React from 'react';


const Header = () => {
  return (
    <header className="header">
      <h1>Echofu Ojunugwa Paul</h1>
    </header>
  );
};

export default Header;
